import { loadStripe } from '@stripe/stripe-js';
import { CONFIG } from '../../../config';

// Memoize a single loadStripe() promise for the whole app. loadStripe injects
// Stripe.js once and caches it, but @stripe/react-stripe-js still expects a
// stable promise reference — recreating it per render remounts the embedded
// checkout iframe. Keep this the one source of the Stripe instance.
let stripePromise;

export function getStripe() {
  if (!stripePromise) {
    stripePromise = loadStripe(CONFIG.STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
}
